import getStorePrefix from './getStorePrefix'
const sluglify = require('./sluglify')


const getCategoryLink = (cat, store) => {
    const prefix = getStorePrefix(store)
    return `${prefix}/${sluglify(cat)}`
}

export default getCategoryLink;